<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import A from "../lib/Router/A.svelte";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {sort, copyObjectData} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import TransporterEdit from "./TransporterEdit.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";


    let transporters = null;
    let transporterId = 0;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE TRANSPORTER', link: '/app/transporter/create', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', link: '/app/transporter/create', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            transporters = result;
        }

        const onFailure = err => {
        };

        R.handle(R.transporter.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail: column}) => {
        transporters = sort(transporters, column.key, column.sort_way === 'ASC');
    }

    const updateRecord = (transporter) => {
        let trans = transporters.find(x => x.id === transporter.id);
        if (!trans) {
            transporters = [transporter, ...transporters];
        } else {
            copyObjectData(transporter, trans);
        }
        transporters = transporters;
    }

    const onEdit = (transporter) => {
        transporterId = transporter.id;
        router.go(`/app/transporter/${transporterId}`)();
    }

    const onDelete = (transporter) => {
        Alert.delete("Delete Transporter", `This will permanently delete transporter "${transporter.name}".\nAre you sure?`, () => deleteTransporter(transporter.id));
    }

    const deleteTransporter = (id) => {
        const onSuccess = result => {
            transporters = transporters.filter(x => x.id !== result);
            Notifier.showMessage("Transport company deleted");
        }

        const onFailure = err => {
            if (err.code) {
                if (err.code === 'not_allowed') {
                    Alert.warning("Delete transporter", "Transporter is associated with application settings.\nYou can not delete this transporter.");
                    return;
                }

                if (err.code === 'object_related') {
                    let message = [];

    				Object.keys(err.params).map(key => {
    					if (err.params[key] > 0) {
    						message.push(`${err.params[key]} ${key}`);
    					}
    				});

    				Alert.warning("Delete transporter", `Transporter is associated with ${message.join(", ")}.\nYou can not delete this transporter.`);
                }
            }
        };

        R.handle(R.transporter.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<Route exact>
    <PageHeader title="Transporters" controls={ pageHeaderControls } on:reload={ load }/>

    {#if transporters}
        <div class="panel">
            <div class="panel-body">
                {#if transporters.length}
                    <table class="table table-list table-list-border">
                        <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                        <tbody>
                        {#each transporters as transporter}
                            <tr class="row-hover" class:row-selected="{ transporterId === transporter.id }">
                                <td on:click="{ () => onEdit(transporter) }">
                                    <span class="is-link" class:not-active={ transporter.is_active < 1}>
                                        { transporter.name }
                                    </span>
                                </td>
                                <td class="button-column pointer" title="delete transporter"
                                    on:click="{ () => onDelete(transporter) }">
                                    <AppIcon icon="trash" size="16"/>
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                {:else}
                    <div class="panel-pad">
                        <p>
                            There are no transportation companies
                        </p>
                        <A href="/app/transporter/create" class="btn btn-primary">CREATE TRANSPORT COMPANY</A>
                    </div>
                {/if}
            </div>
        </div>
    {/if}
</Route>
<Route match="*" let:router>
    <TransporterEdit changeCallback="{ updateRecord }" transporterId="{ router.star }"/>
</Route>